/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useRef } from 'react'
import { ModalAnuncio } from '../../Modais'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import MobileStepper from '@mui/material/MobileStepper'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import { semFoto } from '../../../assets'
import { AuthContext } from '../../../contexts/AuthContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'

import './stylesCAnun.css'

export default function CompAnuncios() {
  const theme = useTheme()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx, actionsUCtx } = React.useContext(UsuarioContext)
  const [anuncios, setAnuncios] = useState([])
  const [maxSteps, setMaxSteps] = useState(0)
  const [activeStep, setActiveStep] = useState(0)
  const [modalIn, setModalIn] = useState(false)
  const timerRef = useRef(null)

  const handleNext = () => {
    setActiveStep(prevActiveStep => (prevActiveStep + 1) % maxSteps)
    resetTimer()
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => (prevActiveStep - 1 + maxSteps) % maxSteps)
    resetTimer()
  }

  const handleImageClick = index => {
    setModalIn(true)
    setActiveStep(index)
    clearTimer()
  }

  const closeModal = () => {
    setModalIn(false)
    resetTimer()
  }

  const startTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current)
    if (maxSteps === 0) return
    timerRef.current = setInterval(() => {
      setActiveStep(prevActiveStep => (prevActiveStep + 1) % maxSteps)
    }, 5000)
  }

  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current)
      timerRef.current = null
    }
  }

  const resetTimer = () => {
    clearTimer()
    startTimer()
  }

  useEffect(() => {
    if (userUCtx.cidade) {
      actionsUCtx.BuscarAnunciosCidade(userUCtx.cidade).then(res => {
        if (res.length) {
          const array = res.map(item => {
            return {
              ...item,
              imgPath: item.foto,
              label: item.titulo,
            }
          })

          setAnuncios(array)
          setMaxSteps(array.length)
          setActiveStep(0)
        }
      })
    }
  }, [userUCtx.cidade])

  useEffect(() => {
    if (!modalIn) {
      startTimer()
    }
    return () => {
      clearTimer()
    }
  }, [modalIn, anuncios])

  let touchStartX = 0
  let touchEndX = 0

  const handleTouchStart = e => {
    touchStartX = e.changedTouches[0].screenX
  }

  const handleTouchEnd = e => {
    touchEndX = e.changedTouches[0].screenX
    handleGesture()
  }

  const handleGesture = () => {
    if (touchStartX - touchEndX > 50) {
      handleNext()
    }

    if (touchEndX - touchStartX > 50) {
      handleBack()
    }
  }

  return (
    <>
      {anuncios.length > 0 ? (
        <div className='contain-home-functions-promocional'>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
              borderRadius: '5px',
            }}
          >
            {modalIn && <ModalAnuncio show={modalIn} ClosedModal={closeModal} anuncio={anuncios[activeStep]} />}
            <Paper
              square
              elevation={0}
              sx={{
                display: 'flex',
                alignItems: 'center',
                height: 'auto',
              }}
            >
              {!sttAuthCtx.isMobile ? (
                <Typography
                  sx={{
                    fontFamily: 'jost-light',
                    width: '100%',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: '18px',
                    marginBottom: '5px',
                  }}
                >
                  {anuncios[activeStep].label}
                </Typography>
              ) : null}
            </Paper>
            {!sttAuthCtx.isMobile ? (
              <div className='contain-img-anuncio'>
                <Box
                  component='img'
                  sx={{
                    height: 207,
                    display: 'flex',
                    maxWidth: 400,
                    objectFit: 'cover',
                    objectPosition: 'center',
                    overflow: 'hidden',
                    borderRadius: 2,
                    width: '100%',
                    cursor: 'pointer',
                  }}
                  src={anuncios[activeStep].imgPath}
                  alt={anuncios[activeStep].label}
                  onClick={() => handleImageClick(activeStep)}
                  onError={e => {
                    e.target.src = semFoto
                  }}
                />
              </div>
            ) : (
              <div className='contain-img-anuncio' onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                <Box
                  component='img'
                  sx={{
                    height: '110px',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    overflow: 'hidden',
                    borderRadius: 2,
                    width: '100vw',
                    cursor: 'pointer',
                  }}
                  src={anuncios[activeStep].imgPath}
                  alt={anuncios[activeStep].label}
                  onClick={() => handleImageClick(activeStep)}
                  onError={e => {
                    e.target.src = semFoto
                  }}
                />
              </div>
            )}
            {!sttAuthCtx.isMobile && (
              <MobileStepper
                steps={maxSteps}
                position='static'
                activeStep={activeStep}
                sx={{
                  maxWidth: 400,
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
                nextButton={
                  <Button size='small' onClick={handleNext} disabled={activeStep === maxSteps - 1} sx={{ fontFamily: 'jost-light' }}>
                    Próximo
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                  </Button>
                }
                backButton={
                  <Button size='small' onClick={handleBack} disabled={activeStep === 0} sx={{ fontFamily: 'jost-light' }}>
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                    Anterior
                  </Button>
                }
              />
            )}
          </Box>
        </div>
      ) : null}
    </>
  )
}
